import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StyledHeader from './components/SectionHeader';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
  PageLead,
} from '../content/components';
import { ContentSection } from '../layout/components';

import {
  OpenPositionsBlock,
  LinkList
} from './components';

import {
  BleedSectionLandscapeLeft,
  BleedSectionPortraitRight,
} from './components/sections';

class CareersPage extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
  };

  render() {
    const { breakpoint } = this.props;
    return (
      <ContentProvider
        slug="careers"
        render={({
          header,
          intro,
          open_positions,
          open_positions_list,
          primary,
          secondary,
          cross_links,
          wacky_facts_title,
          wacky_facts,
          newsletter_text,
          default_open_positions_link,
        }) => (
          <PageContainer>
            <PageHeader mainImage={header.main_image} />
            <PageLead
              title={header.title}
              subtitle={header.subtitle}
              content={intro.content}
              links={intro.links}
              supportImage={
                header.support_media_format === 'circular'
                  ? header.support_image_circular
                  : header.support_image_portrait
              }
              supportVideo={header.support_video}
              supportMediaType={header.support_media_type}
              supportIsCircular={header.support_media_format === 'circular'}
            />
            <ContentSection title="">
              <LinkList
                items={[{
                  href: `https://apply.workable.com/space-ape-games/`,
                  label: "Click here to check out our open opportunities"
                }]}
              />
            </ContentSection>

            {/* commented out: LM 2023-06-06 on request of recruitment team */}
            {/*{open_positions_list && open_positions_list.length > 0 ? (*/}
            {/*  <ContentSection title="we are currently on the lookout for">*/}
            {/*    <LinkList*/}
            {/*       items={open_positions_list.map(position => ({*/}
            {/*         href: `/careers/${position.category}/${position.slug}`,*/}
            {/*         label: position.title,*/}
            {/*       }))}*/}
            {/*    />*/}
            {/*  </ContentSection>*/}
            {/*      */}
            {/*) : (*/}
            {/*  */}
            {/*  <ContentSection title="we are currently on the lookout for">*/}
            {/*    <p*/}
            {/*      style={{*/}
            {/*        margin: '0 auto 1.6em',*/}
            {/*        maxWidth: '520px',*/}
            {/*        textAlign: 'center',*/}
            {/*      }}>*/}
            {/*      We currently have no open positions.</p>*/}
            {/*  </ContentSection>*/}
            {/*)}*/}

            <ContentSection title="Find out more about our teams">
              {open_positions.terms.map(category => (
                <OpenPositionsBlock
                  key={category.slug}
                  category={category.title}
                  slug={category.slug}
                  numPositions={category.count}
                  totalPositions={open_positions.total}
                  linkTo={`/careers/${category.slug}`}
                />
              ))}
            </ContentSection>
              
              

            <BleedSectionLandscapeLeft
              breakpoint={breakpoint}
              subTitle={primary.subtitle}
              title={primary.title}
              mainImage={primary.main_image}
              supportImage={primary.support_image}
              supportVideo={primary.support_video}
              supportMediaType={primary.support_media_type}
              renderContent={() => (
                <div dangerouslySetInnerHTML={{ __html: primary.content }} />
              )}
              links={primary.links}
            />

            <BleedSectionPortraitRight
              breakpoint={breakpoint}
              subTitle={secondary.subtitle}
              title={secondary.title}
              mainImage={secondary.main_image}
              supportImage={secondary.support_image}
              supportVideo={secondary.support_video}
              supportMediaType={secondary.support_media_type}
              renderContent={() => (
                <div dangerouslySetInnerHTML={{ __html: secondary.content }} />
              )}
              links={secondary.links}
            />

          </PageContainer>
        )}
      />
    );
  }
}

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(CareersPage);



// WEBPACK FOOTER //
// ./src/modules/pages/CareersPage.js